import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Footer } from '../components/Footer';
import { useTranslation } from '../lib/i18n';
export function Impressum() {
  const {
    t
  } = useTranslation();
  return <HelmetProvider data-id="element-173">
      <div className="min-h-screen bg-background text-text-primary font-sans flex flex-col" data-id="element-174">
        <Helmet data-id="element-175">
          <title data-id="element-176">Impressum | Caro Loesel</title>
          <meta name="robots" content="noindex, nofollow" data-id="element-177" />
        </Helmet>

        <main className="flex-grow container mx-auto px-4 py-12 md:py-20 max-w-3xl" data-id="element-178">
          <Link to="/" className="inline-flex items-center text-hotpink hover:text-hotpink/80 transition-colors mb-8 font-medium" data-id="element-179">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-180" />
            {t.legal.backToHome}
          </Link>

          <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-8" data-id="element-181">
            Impressum
          </h1>

          <div className="space-y-8 text-text-secondary leading-relaxed" data-id="element-182">
            <section data-id="element-183">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-184">
                Angaben gemäß § 5 TMG
              </h2>
              <p data-id="element-185">
                EXXOTIC Management UG
                <br data-id="element-186" />
                Äußere Bayreuther Str. 59
                <br data-id="element-187" />
                90409 Nürnberg
                <br data-id="element-188" />
                Deutschland
              </p>
            </section>

            <section data-id="element-189">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-190">
                Kontakt
              </h2>
              <p data-id="element-191">
                E-Mail: info@exxotic-management.com
                <br data-id="element-192" />
                Webseite: www.caroloesel.com
              </p>
            </section>

            <section data-id="element-193">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-194">
                Registereintrag
              </h2>
              <p data-id="element-195">
                Eintragung im Handelsregister.
                <br data-id="element-196" />
                Registergericht: Amtsgericht Nürnberg
                <br data-id="element-197" />
                Registernummer: HRB 41546
              </p>
            </section>

            <section data-id="element-198">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-199">
                Umsatzsteuer-ID
              </h2>
              <p data-id="element-200">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                Umsatzsteuergesetz:
                <br data-id="element-201" />
                DE419617625
              </p>
            </section>

            <section data-id="element-202">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-203">
                Steuernummer
              </h2>
              <p data-id="element-204">241/125/92853</p>
            </section>

            <section data-id="element-205">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-206">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p data-id="element-207">
                EXXOTIC Management UG
                <br data-id="element-208" />
                Äußere Bayreuther Str. 59
                <br data-id="element-209" />
                90409 Nürnberg
              </p>
            </section>

            <section data-id="element-210">
              <h2 className="text-xl font-heading font-semibold text-text-primary mb-4" data-id="element-211">
                Haftungsausschluss
              </h2>
              <p className="mb-4" data-id="element-212">
                <strong data-id="element-213">Haftung für Inhalte</strong>
                <br data-id="element-214" />
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
                hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst
                ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
                möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen
                werden wir diese Inhalte umgehend entfernen.
              </p>
              <p data-id="element-215">
                <strong data-id="element-216">Haftung für Links</strong>
                <br data-id="element-217" />
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar. Eine permanente inhaltliche
                Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
                Bekanntwerden von Rechtsverletzungen werden wir derartige Links
                umgehend entfernen.
              </p>
            </section>
          </div>
        </main>

        <Footer data-id="element-218" />
      </div>
    </HelmetProvider>;
}